import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

const LEGACY_PREFIX = '/mtpn-time';
const OMEGA_PREFIX = '/omega';

export function mapLegacyMtpnTimeUrl(url: string): string {
  const [, path = '', suffix = ''] = url.match(/^([^?#]*)(.*)$/) ?? [];
  const remainder = path.slice(LEGACY_PREFIX.length);

  if (remainder === '' || remainder === '/') {
    return `${OMEGA_PREFIX}/timekeeping${suffix}`;
  }

  if (remainder === '/tools/servcieMan' || remainder.startsWith('/tools/servcieMan/')) {
    return `${OMEGA_PREFIX}/tools/serviceman${remainder.slice('/tools/servcieMan'.length)}${suffix}`;
  }

  if (remainder === '/tools' || remainder.startsWith('/tools/')) {
    return `${OMEGA_PREFIX}/tools${remainder.slice('/tools'.length)}${suffix}`;
  }

  if (remainder === '/messages' || remainder.startsWith('/messages/')) {
    return `${OMEGA_PREFIX}/messages${remainder.slice('/messages'.length)}${suffix}`;
  }

  return `${OMEGA_PREFIX}/timekeeping${remainder}${suffix}`;
}

@Injectable({
  providedIn: 'root'
})
export class LegacyMtpnTimeRedirectGuard implements CanActivate {
  private router = inject(Router);

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): UrlTree {
    return this.router.parseUrl(mapLegacyMtpnTimeUrl(state.url));
  }
}
